module.exports = __webpack_public_path__ + "Roboto-Light.cd41ae1ccbe83db135c8.svg";


//////////////////
// WEBPACK FOOTER
// /Users/vladislavlazurenko/IdeaProjects/luiziana/frontend/src/roboto-fontface/fonts/roboto/Roboto-Light.svg
// module id = ../../../../../src/roboto-fontface/fonts/roboto/Roboto-Light.svg
// module chunks = styles